import React from 'react';
import ContactInfoWidget from '../Widget/ContactInfoWidget';
import MenuWidget from '../Widget/MenuWidget';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import TextWidget from '../Widget/TextWidget';
import { Link } from 'react-router-dom';
// const menuDataOne = [
//   { title: 'About Us', href: '/about' },
//   { title: 'Departments', href: '/departments' },
//   { title: 'Doctors', href: '/doctors' },
//   { title: 'Timetable', href: '/timetable' },
//   { title: 'Appointment', href: '/appointments' },
//   { title: 'Testimonials', href: '/' },
// ];
const menuDataTwo = [
  { title: 'Home', href: '/' },
  { title: 'Blog', href: '/blog' },
  { title: 'About', href: '/about' },
  { title: 'Terms & Conditions', href: '/termscondition' },
  { title: 'Privacy Policies', href: '/privacypolicy' },
];

export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: 'url(/images/footer_bg_1.svg)' }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: 'url(/images/footer_logo_bg.svg)' }}
        >
          <img
            src="/images/about/logo.png"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
            style={{ width: "45%" }}
          />
          <h2 className="cs_footer_brand_text">GKC Klinica</h2>
        </div>
      </div>
      <div className="cs_footer_main bg-gradient-to-r from-[#6a6fb3] via-[#8a6aa6] to-[#d46a6a] text-white pt-20 pb-16">
  <div className="container">
    <div className="row">

      {/* COLUMN 1 - HEALTH */}
      <div className="col-lg-3 col-md-6 mb-4">
        <h5 className="font-bold mb-4">Health</h5>
        <ul className="space-y-2 text-sm opacity-90" style={{ color: "#274760" }}>
          {/* <li>MediBuddy Gold</li> */}
          <li><Link to="/">Book Medicines</Link></li>
          <li><Link to="https://app.gkcklinica.com/public-profiles">Doctor Consultation</Link></li>
          <li><Link to="/pricing-plan">Book a Lab test</Link></li>
          <li>Covid Essential Items</li>
          <li><Link to="https://app.gkcklinica.com/public-profiles">Surgery Care</Link></li>
          <li><Link to="https://app.gkcklinica.com/public-profiles">Dental</Link></li>
          <li><Link to="https://app.gkcklinica.com/public-profiles">Cancer Care</Link></li>
          <li>Partner with GKC Klinica</li>
        </ul>
      </div>

      {/* COLUMN 2 - HOSPITALIZATION */}
      <div className="col-lg-3 col-md-6 mb-4">
        <h5 className="font-bold mb-4">Hospitalization</h5>
        <ul className="space-y-2 text-sm opacity-90" style={{ color: "#274760" }}>
          <li><Link to="https://app.gkcklinica.com/public-profiles">Locate hospital</Link></li>
          <li>Download eCard</li>
          <li>Track claim</li>
          <li><Link to="/faq">FAQs</Link></li>
        </ul>

        <h6 className="font-semibold mt-6 mb-2">Our Policies</h6>
        <ul className="space-y-2 text-sm opacity-90" style={{ color: "#274760" }}>
          <li><Link to="/TermsCondition">Terms of Use</Link></li>
          <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
          <li>Grievance Redressal</li>
          <li>Cancellation & Refund Policy</li>
          <li>Security at GKC Klinica</li>
        </ul>
      </div>

      {/* COLUMN 3 - ABOUT */}
      <div className="col-lg-3 col-md-6 mb-4">
        <h5 className="font-bold mb-4">ABOUT</h5>
        <ul className="space-y-2 text-sm opacity-90" style={{ color: "#274760" }}>
          <li><Link to="/">Overview</Link></li>
          <li><Link to="/">Corporate Plans</Link></li>
          <li><Link to="/about">Testimonials</Link></li>
          <li><Link to="/PrivacyPolicy">Contact</Link></li>
          <li><Link to="/blog">Blog</Link></li>
          <li><Link to="/about">Careers</Link></li>
          <li><Link to="/">Security</Link></li>
          <li><Link to="/">Medical Value Travel</Link></li>
          <li><Link to="/">GKC Klinica Beliefs</Link></li>
        </ul>
      </div>

      {/* COLUMN 4 - APP + SOCIAL */}
      <div className="col-lg-3 col-md-6 mb-4">
        <h5 className="font-bold mb-4">DOWNLOAD APP</h5>

        <div className="flex gap-3 mb-6">
          <a href="https://play.google.com/store/apps/details?id=com.gkcklinica.GkcKlinica&hl=en_IN" target="_blank" >
            <img src="/images/g-play-btn.png" className="h-10" />
          </a>
          <a href="https://apps.apple.com/in/app/gkc-klinica/id6670213393" target="_blank" >
            <img src="/images/ios-btn.png" className="h-10" />
          </a>
        </div>

        {/* <h5 className="font-bold mb-3">FOLLOW US</h5> */}

        {/* <div className="flex gap-3">
          <SocialWidget />
        </div> */}
      </div>

    </div>
  </div>
</div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © {new Date().getFullYear()}  GKC Klinica. All rights reserved.
            </div>
          </div>
        </div>   
      </div>
    </footer>
  );
}
